module.exports = __webpack_public_path__ + "static/media/OpenSans-Semibold.2d360fe1.woff2";